import { render, staticRenderFns } from "./SignButton.vue?vue&type=template&id=53836d30&scoped=true&"
import script from "./SignButton.vue?vue&type=script&lang=js&"
export * from "./SignButton.vue?vue&type=script&lang=js&"
import style0 from "./SignButton.vue?vue&type=style&index=0&id=53836d30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53836d30",
  null
  
)

export default component.exports